export enum Status {
  BURN = "BURN",
  SILENCE = "SILENCE",
  POISON = "POISON",
  FREEZE = "FREEZE",
  PROTECT = "PROTECT",
  SLEEP = "SLEEP",
  CONFUSION = "CONFUSION",
  CHARM = "CHARM",
  WOUND = "WOUND",
  RESURECTION = "RESURECTION",
  RESURECTING = "RESURECTING",
  PARALYSIS = "PARALYSIS",
  ARMOR_REDUCTION = "ARMOR_REDUCTION",
  RUNE_PROTECT = "RUNE_PROTECT",
  ELECTRIC_FIELD = "ELECTRIC_FIELD",
  PSYCHIC_FIELD = "PSYCHIC_FIELD",
  GRASS_FIELD = "GRASS_FIELD",
  FAIRY_FIELD = "FAIRY_FIELD",
  SPIKE_ARMOR = "SPIKE_ARMOR",
  MAGIC_BOUNCE = "MAGIC_BOUNCE"
}
